// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12C2U","toggleWrap":"styles_toggleWrap__2H-Bu","content":"styles_content__23QEv","selectAreaCode":"styles_selectAreaCode__2uZX1"};